// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"335fcbcd","5236":"36df0764","6666":"ada2e0a6","7519":"6de17d71"}[chunkId] + ".chunk.css";
};